import React = require("react");

export const Debounce = <a,>(props: {
  value: a
  effect: (_: a) => void
  timeout: number
}) => {
  React.useEffect(() => {
    const run = setTimeout(
      () => props.effect(props.value), 
      props.timeout
    )
    return () => clearTimeout(run)
  }, [props.value])
  
  return (<></>)
}